import React, { useEffect, useState } from "react";
import data from "../data";
import styles from "./TableView.module.css";
import FlipMove from "react-flip-move";
import TableRows from "./TableRows";

const TableView = () => {
  const [playersData, setPlayersData] = useState(data);
  const [updatedPlayersData, setUpdatedPlayersData] = useState([]);
  const randomScorefn = () => {
    const random = Math.floor(Math.random() * 72835);
    return random;
  };

  const updateArr = () => {
    // alternative way to update score
    const randomIndex = Math.floor(Math.random() * 10);

    let updatedArr = playersData.map((player, index) => {
      if (randomIndex === index) {
        return { ...player, score: randomScorefn(), color: "yellow" };
      } else {
        return player;
      }
    });

    const sortedArr = updatedArr.slice().sort((a, b) => b.score - a.score);
    setPlayersData(sortedArr);
    setUpdatedPlayersData(playersData);
  };

  useEffect(() => {
    let time = setTimeout(() => {
      updateArr();
    }, 1000);

    return () => clearTimeout(time);
  }, [updatedPlayersData]);

  return (
    <div className={styles.tableSize}>
      <div>
        <div className={styles.table} key={0}>
          <div className={styles.ranking}>Ranking</div>
          <div className={styles.name}>Name</div>
          <div className={styles.score} textAlign="right">
            Score
          </div>
        </div>

        <div>
          <FlipMove
            style={{ width: "800px" }}
            typeName={null}
            duration={500}
            staggerDurationBy="30"
          >
            {playersData?.map(({ id, playerName, score, color }, idx) => {
              if (idx === 0) color = "#F0F5D2";
              else if (idx === 1) color = "#DDF5F7";
              else if (idx === 2) color = "#FEE8C4";
              else color = "white";

              return (
                <div key={id} id={idx}>
                  <TableRows
                    key={id}
                    rankingNumber={idx + 1}
                    playerName={playerName}
                    score={score}
                    color={color}
                  />
                </div>
              );
            })}
          </FlipMove>
        </div>
      </div>
    </div>
  );
};

export default TableView;
